import { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"

function removeUpToLast(str: string, substring: string): string {
  const idx = str.lastIndexOf(substring)
  return idx !== -1 ? str.substring(idx + substring.length) : str
}

export function getNonUmbracoUrl(url?: string, prePath?: string) {
  if (!url) {
    return "/"
  }

  // Extract anchor/hash if present
  const hashIndex = url.indexOf("#")
  const anchor = hashIndex !== -1 ? url.slice(hashIndex) : ""
  const urlWithoutAnchor = hashIndex !== -1 ? url.slice(0, hashIndex) : url

  if (urlWithoutAnchor?.includes("/media/")) {
    return getUmbracoMediaUrl(urlWithoutAnchor) + anchor
  }
  if (urlWithoutAnchor?.includes("pages/home")) {
    const basePath = urlWithoutAnchor?.includes("en-us")
      ? prePath
        ? "/en" + prePath
        : "/en"
      : prePath
      ? prePath
      : "/"
    return basePath + anchor
  }
  if (urlWithoutAnchor?.includes("/shared")) {
    const result = urlWithoutAnchor?.includes("en-us")
      ? "/en" + removeUpToLast(urlWithoutAnchor, "/general-information")
      : removeUpToLast(urlWithoutAnchor, "/general-information") || "/"
    return result + anchor
  }

  if (!urlWithoutAnchor?.includes("pages")) {
    if (urlWithoutAnchor?.includes("/he-il/")) {
      return urlWithoutAnchor.replace(/\/he-il/, "") + anchor
    }
    if (urlWithoutAnchor?.includes("/en-us/")) {
      return "/en" + urlWithoutAnchor.replace(/\/en-us/, "") + anchor
    }
    return url
  }
  const pathAfterPages = removeUpToLast(urlWithoutAnchor, "/pages")
  const result = urlWithoutAnchor?.includes("en-us")
    ? "/en" + (prePath ? prePath + pathAfterPages : pathAfterPages)
    : (prePath ? prePath + pathAfterPages : pathAfterPages) || "/"
  return result + anchor
}
